import { ModalMode, SeasonsState } from '@/views/seasons/seasons.types';
import { fields, generateDays }    from '@/views/seasons/helpers/season.helpers';

const state: SeasonsState = {
  loading: false,
  selection: {
    start: null,
    end: null,
    seasonCode: null,
  },
  seasons: [],
  modal: {
    open: false,
    mode: 'CREATE' as ModalMode,
    form: {
      fields: fields(),
      originalFields: fields(),
    },
  },
  calendar: {
    0: generateDays(31),
    1: generateDays(29),
    2: generateDays(31),
    3: generateDays(30),
    4: generateDays(31),
    5: generateDays(30),
    6: generateDays(31),
    7: generateDays(31),
    8: generateDays(30),
    9: generateDays(31),
    10: generateDays(30),
    11: generateDays(31),
  },
};

export default state;
